import Modal from './components/Modal';

export default Modal;



// WEBPACK FOOTER //
// ./src/components/modal/index.jsx